// extracted by mini-css-extract-plugin
export default {"phone_inp":"CustomPhoneInput_phone_inp__vZBZx","phone_input_container":"CustomPhoneInput_phone_input_container__YdCr1","phone_inp_error":"CustomPhoneInput_phone_inp_error__CoYU7"};